import React from 'react';

import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { withEventScope } from '@repo/event-processor';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import VectorizerTool from 'components/Vectorizer/VectorizerTool/VectorizerTool';

const Vectorizer: React.FC<
  SliceComponentProps<Content.VectorizerSlice>
> = () => {
  return (
    <ContentWrapper className="vectorizer" customWidth="1116px">
      <VectorizerTool />
    </ContentWrapper>
  );
};

export default withEventScope(Vectorizer, { feature: 'vectorizer' });
